/**
 * PAPPO — Conversations Service
 * Comunicação com a API de conversas (/api/conversations).
 */

import { apiGet, apiPost } from './api';
import type { Conversation, Message } from '../types/message';

/** Lista as conversas do utilizador atual */
export async function listConversations() {
  return apiGet<{ conversations: Conversation[] }>('/conversations');
}

/** Obtém ou cria uma conversa com outro utilizador */
export async function createConversation(userId: number) {
  return apiPost<{ conversation: Conversation }>('/conversations', {
    user_id: userId,
  });
}

/** Histórico de mensagens de uma conversa */
export async function getMessages(conversationId: number) {
  return apiGet<{ messages: Message[] }>(
    `/conversations/${conversationId}/messages`
  );
}
